module.exports = __webpack_public_path__ + "img/zhiyao2.69ed18d1.png";